import { LoadingStatuses } from 'core/common/entities';
import { getRandomNumberWithinRange } from 'core/common/utils/getRandomNumberWithinRange';
import { Gender, RelationshipStatuses, RelationshipType } from 'core/flow/entities';
import { ZodiacTypes } from 'core/zodiac/entities';
import { UserProfile, UserType } from '../../entities';

export const userProfileInitialState: UserProfile = {
  orderId: '',
  gender: Gender.FEMALE,
  date: '',
  zodiac: ZodiacTypes.AQUARIUS,
  place: [],
  location: null,
  time: null,
  partnerGender: '',
  partnerIdealAge: '',
  partnerDate: '',
  partnerZodiac: '',
  totalUsersGenderZodiac: '',
  partnerPlace: [],
  partnerLocation: null,
  partnerTime: null,
  email: '',
  name: '',
  partnerName: '',
  initialStep: '',
  step: 0,
  // todo: unify the property of relationshipType
  relationshipStatus: RelationshipStatuses.SINGLE,
  relationshipType: RelationshipType.SINGLE,
  id: '',
  currentlyAffecting: [],
  relationshipGoal: '',
  quizLength: '',
  astrologyKnowledge: '',
  relateToStatement: '',
  mostImportant: '',
  goodEnough: '',
  idealDate: '',
  futurePartner: '',
  idealPartner: '',
  decisions: '',
  birthTime: '',
  birth_date: '',
  palmReadingGoal: '',
  wpGoal: '',
  challenges: '',
  relationship: '',
  mainPain: '',
  mainGoal: '',
  topics: '',
  updateUserInformationStatus: LoadingStatuses.IDLE,
  downloadAppLink: '',
  downloadAppLinkLoadingStatus: LoadingStatuses.IDLE,
  // TODO fix on prod/stage builder
  ancestor_data: '',
  nature_data: '',
  tradition_data: '',
  crowdComfort_data: '',
  intuitiveHealing_data: '',
  moonPhase_data: '',
  worryPartnerLeaves: '',
  archetype: '',
  traumaScore: getRandomNumberWithinRange(7, 8),
  relationshipSuccessDay: getRandomNumberWithinRange(1, 28),
  nebulaId: '',
  userType: UserType.UNKNOWN,
  holdingBackReason: '',
  ethnicBackground: '',
  manifestHasPerson: '',
  loveLanguage: '',
  partnerSimilarityPreference: '',
  relationshipFear: '',
  feelEmpowered: '',
  peacePlaces: [],
  animalsConnection: '',
  elementAffinity: '',
  emotionExpress: '',
  effectOnOthers: '',
  relationshipRoleRepair: '',
  practices: [],
  colorPreference: [],
  respondWhenHurt: '',
  periodPreference: '',
  idealRelationshipDynamic: '',
};
